<template>
  <div class="CoalTypeManagement_box">
    <div v-if="!isAdjust">
      <div class="CoalTypeManagement_box_title">
        <div class="CoalTypeManagement_box_title_desc">首页</div>
      </div>
      <el-divider></el-divider>
      <div class="home_index_box">
        欢迎您：<span style="padding-left: 10px;color: #f22; font-weight: 600;font-size: 25px">{{name}}</span>
      </div>
    </div>
    <!--使用说明-->
    <Instruction v-if="isAdjust" @Adjust="AdjustFun"/>
  </div>
</template>
<script>
// import KtButton from '@/components/Core/KtButton'
import Instruction from './Instruction'

export default {
  components: {
    Instruction
  },
  data() {
    return {
      size: 'small',
      isAdjust: false,
      name: localStorage.getItem('name')
    }
  },
  mounted() {
  },
  methods: {
    // 点击使用说明
    getAdjust() {
      const _t = this
      _t.isAdjust = true
    },
    // 接受使用说明子组件传回的值
    AdjustFun(val) {
      const _t = this
      _t.isAdjust = val
    }
  }
}
</script>
<style lang="scss">
  .CoalTypeManagement_box{
    box-sizing: border-box;
    padding: 10px;
  }
  .CoalTypeManagement_box_title {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 0 0;

    .CoalTypeManagement_box_title_desc {
      font-size: 18px;
      font-weight: 600;
    }

    .CoalTypeManagement_box_title_cz {
      color: #25aff3;
      cursor: pointer;
    }
  }

  .home_index_box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
    font-weight: 600;
    font-size: 22px;
  }
</style>
